import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useRoutingUserDetails } from '@/hooks/useRoutingUserDetails';
import { UserRole } from '@cargovibe/shared-types';
import type { RoutingUserDetails } from '@/lib/api/routingApi';
import type { UseQueryResult } from '@/lib/query';

interface RequireRoleProps {
  role: UserRole;
  children: ReactNode;
}

/**
 * Redirects to `/users` unless the signed-in user has the given role.
 * Backed by `/getUserDetails` (the DB role) rather than Clerk metadata, which
 * nothing in this codebase populates.
 */
export function RequireRole({ role, children }: RequireRoleProps): React.JSX.Element {
  const { data }: UseQueryResult<RoutingUserDetails | null> = useRoutingUserDetails();

  if (data?.role !== role) return <Navigate to="/users" replace />;

  return <>{children}</>;
}
